import React, { useContext, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

import AppPageTitle from "../components/AppPageTitle";
import { i18n } from "../translate/i18n";
import noTickets from "../assets/noTickets.png";
import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";
import { AuthContext } from "../context/Auth/AuthContext";

function normalizePath(path) {
	return String(path || "").toLowerCase();
}

function AdminIcon({ children }) {
	return (
		<span className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
			<svg className="size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
				{children}
			</svg>
		</span>
	);
}

function getAdminItems(connectionWarning) {
	return [
		{
			id: "connections",
			path: "/connections",
			title: i18n.t("mainDrawer.listItems.connections"),
			description: "Gerencie conexões e acompanhe o status dos canais.",
			icon: (
				<AdminIcon>
					<path d="M7 17 17 7" />
					<path d="M7 7h10v10" />
				</AdminIcon>
			),
			badge: connectionWarning ? "Atenção" : null,
		},
		// {
		// 	id: "sales-funnel",
		// 	path: "/sales-funnel",
		// 	title: "Funil de vendas",
		// 	description: "Acompanhe seu funil de conversão e oportunidades.",
		// 	icon: (
		// 		<AdminIcon>
		// 			<path d="M4 5h16" />
		// 			<path d="M7 12h10" />
		// 			<path d="M10 19h4" />
		// 		</AdminIcon>
		// 	),
		// },
		{
			id: "agent-ia",
			path: "/AgenteIa",
			title: "Agente IA",
			description: "Crie e configure assistentes virtuais.",
			icon: (
				<AdminIcon>
					<path d="M9 18h6" />
					<path d="M10 22h4" />
					<path d="M12 2a7 7 0 0 0-4 12.75c.6.42 1 1.07 1 1.8V17h6v-.45c0-.73.4-1.38 1-1.8A7 7 0 0 0 12 2Z" />
				</AdminIcon>
			),
		},
		{
			id: "trigger-funnels",
			path: "/triggerFunnels",
			title: "Gatilhos para Funis",
			description: "Automatize mensagens e eventos do funil.",
			icon: (
				<AdminIcon>
					<path d="M13 2 4 14h6l-1 8 9-12h-6l1-8Z" />
				</AdminIcon>
			),
		},
		{
			id: "avaliations",
			path: "/avaliations",
			title: "Avaliações",
			description: "Veja o feedback e a satisfação dos clientes.",
			icon: (
				<AdminIcon>
					<path d="M7 10v12" />
					<path d="M12 4v18" />
					<path d="M17 8v14" />
				</AdminIcon>
			),
		},
		{
			id: "whatsappMetrics",
			path: "/whatsapp-metrics",
			title: "Métricas WhatsApp",
			description: "Volume da Meta, estimativa de custo e retorno dos templates.",
			icon: (
				<AdminIcon>
					<path d="M4 19V5" />
					<path d="M4 19h16" />
					<path d="M8 16v-5" />
					<path d="M12 16V8" />
					<path d="M16 16v-3" />
				</AdminIcon>
			),
		},
		{
			id: "reports",
			path: "/reports",
			title: "Relatórios",
			description: "Acesse dados e estatísticas operacionais.",
			icon: (
				<AdminIcon>
					<path d="M8 6h8" />
					<path d="M8 10h8" />
					<path d="M8 14h5" />
					<path d="M6 2h9l5 5v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z" />
				</AdminIcon>
			),
		},
		{
			id: "adminAiReports",
			path: "/admin-ai-reports",
			title: "Relatório IA",
			description: "Gere análises dinâmicas da equipe com inteligência artificial.",
			icon: (
				<AdminIcon>
					<path d="M12 2a4 4 0 0 1 4 4v1h1a3 3 0 0 1 0 6h-.5" />
					<path d="M8 13H7a3 3 0 0 1 0-6h1V6a4 4 0 0 1 4-4" />
					<path d="M9 17h6" />
					<path d="M10 21h4" />
					<path d="M12 13v4" />
				</AdminIcon>
			),
		},
		{
			id: "users",
			path: "/users",
			title: i18n.t("mainDrawer.listItems.users"),
			description: "Gerencie usuários e níveis de acesso.",
			icon: (
				<AdminIcon>
					<path d="M17 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2" />
					<circle cx="10" cy="7" r="4" />
					<path d="M23 21v-2a4 4 0 0 0-3-3.87" />
					<path d="M16 3.13a4 4 0 0 1 0 7.75" />
				</AdminIcon>
			),
		},
		{
			id: "queues",
			path: "/Queues",
			title: i18n.t("mainDrawer.listItems.queues"),
			description: "Configure setores e fluxos de atendimento.",
			icon: (
				<AdminIcon>
					<path d="M6 6h15" />
					<path d="M6 12h15" />
					<path d="M6 18h15" />
					<path d="M3 6h.01" />
					<path d="M3 12h.01" />
					<path d="M3 18h.01" />
				</AdminIcon>
			),
		},
		{
			id: "follow-up",
			path: "/FollowUp",
			title: i18n.t("mainDrawer.listItems.followUp"),
			description: "Mensagem automática se o cliente não responder a você.",
			icon: (
				<AdminIcon>
					<circle cx="12" cy="12" r="10" />
					<polyline points="12 6 12 12 16 14" />
				</AdminIcon>
			),
		},
		{
			id: "templates",
			path: "/Templates",
			title: "Templates",
			description: "Modelos de mensagens e estruturas reutilizáveis.",
			icon: (
				<AdminIcon>
					<path d="M9 3h6l4 4v14H5V3h4Z" />
					<path d="M9 3v5h6" />
					<path d="M9 13h6" />
					<path d="M9 17h6" />
				</AdminIcon>
			),
		},
		{
			id: "integrations",
			path: "/integrations",
			title: i18n.t("integrations.title"),
			description: i18n.t("integrations.subtitle"),
			icon: (
				<AdminIcon>
					<path d="M8 12h8" />
					<path d="M12 8v8" />
					<circle cx="6" cy="12" r="2" />
					<circle cx="18" cy="12" r="2" />
					<circle cx="12" cy="6" r="2" />
					<circle cx="12" cy="18" r="2" />
				</AdminIcon>
			),
		},
		{
			id: "transactions",
			path: "/transactions",
			title: i18n.t("transactions.title"),
			description: i18n.t("transactions.subtitle"),
			icon: (
				<AdminIcon>
					<rect x="2" y="5" width="20" height="14" rx="2" />
					<path d="M2 10h20" />
					<path d="M12 15v2" />
					<path d="M8 15h8" />
				</AdminIcon>
			),
		},
		{
			id: "settings",
			path: "/Settings",
			title: i18n.t("mainDrawer.listItems.settings"),
			description: "Ajuste parâmetros e preferências do sistema.",
			icon: (
				<AdminIcon>
					<path d="M12 2v3" />
					<path d="M12 19v3" />
					<path d="m4.93 4.93 2.12 2.12" />
					<path d="m16.95 16.95 2.12 2.12" />
					<path d="M2 12h3" />
					<path d="M19 12h3" />
					<path d="m4.93 19.07 2.12-2.12" />
					<path d="m16.95 7.05 2.12-2.12" />
					<circle cx="12" cy="12" r="4" />
				</AdminIcon>
			),
		},
	];
}

function StatesMain({ drawerClose }) {
	const location = useLocation();
	const { whatsApps } = useContext(WhatsAppsContext);
	const { user } = useContext(AuthContext);

	const offlineConnections = useMemo(
		() =>
			(whatsApps || []).filter((whats) =>
				["qrcode", "PAIRING", "DISCONNECTED", "TIMEOUT", "OPENING"].includes(
					whats.status
				)
			).length,
		[whatsApps]
	);

	const adminItems = useMemo(
		() => getAdminItems(offlineConnections > 0),
		[offlineConnections]
	);

	const summaryCards = [
		{
			label: "Conexões",
			value: whatsApps?.length || 0,
			tone: "text-primary",
		},
		{
			label: "Pendências",
			value: offlineConnections,
			tone: offlineConnections > 0 ? "text-warning" : "text-success",
		},
		{
			label: "Perfil",
			value: user?.profile || "user",
			tone: "text-default-700 dark:text-default-200",
		},
	];

	return (
		<div className="app-admin-page app-admin-hub">
			<div className="app-admin-page__scroll">
				<AppPageTitle
					title={i18n.t("mainDrawer.listItems.administration")}
					subtitle="Central de configurações, acessos e recursos administrativos."
				/>

				<div className="app-admin-hub__layout">
					<aside className="app-admin-hub__menu card">
						<div className="card-header">
							<h6 className="card-title m-0">Menu administrativo</h6>
						</div>
						<div className="app-admin-hub__menu-list divide-y divide-default-200 dark:divide-default-700">
							{adminItems.map((item) => {
								const selected =
									normalizePath(location.pathname) === normalizePath(item.path);

								return (
									<Link
										key={item.id}
										to={item.path}
										onClick={() => drawerClose?.()}
										className={`app-admin-hub__menu-item${selected ? " app-admin-hub__menu-item--active" : ""
											}`}
									>
										{item.icon}
										<div className="app-admin-hub__menu-copy">
											<div className="flex flex-wrap items-center gap-2">
												<h6 className="m-0 text-sm font-semibold text-default-800 dark:text-default-100">
													{item.title}
												</h6>
												{item.badge && (
													<span className="inline-flex rounded px-2 py-0.5 text-[11px] font-medium bg-warning/10 text-warning">
														{item.badge}
													</span>
												)}
											</div>
											<p className="mb-0 mt-1 text-sm text-default-500 dark:text-default-400">
												{item.description}
											</p>
										</div>
										<span className="app-admin-hub__menu-chevron" aria-hidden>
											<svg className="size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
												<path d="m9 6 6 6-6 6" />
											</svg>
										</span>
									</Link>
								);
							})}
						</div>
					</aside>

					<div className="app-admin-hub__aside">
						<div className="card app-admin-hub__hero">
							<div className="app-admin-hub__hero-grid">
								<div className="space-y-4">
									<span className="inline-flex rounded-md bg-primary/10 px-2.5 py-1 text-xs font-semibold uppercase tracking-wide text-primary">
										Painel administrativo
									</span>
									<div className="space-y-2">
										<h2 className="m-0 text-xl font-bold text-default-900 dark:text-default-50 sm:text-2xl">
											{process.env.REACT_APP_NOME}
										</h2>
										<p className="m-0 text-sm text-default-500 dark:text-default-400">
											Escolha uma área no menu para administrar canais, usuários,
											filas, templates e configurações do sistema.
										</p>
									</div>
									{offlineConnections > 0 && (
										<div className="rounded-lg border border-warning/30 bg-warning/10 px-4 py-3 text-sm text-warning">
											{offlineConnections} conexão(ões) exigem atenção no momento.
										</div>
									)}
								</div>
								<div className="app-admin-hub__hero-art">
									<img
										src={noTickets}
										alt="Administração"
										className="max-h-48 w-full max-w-[220px] object-contain opacity-90 sm:max-h-56"
									/>
								</div>
							</div>
						</div>

						<div className="app-admin-hub__stats">
							{summaryCards.map((card) => (
								<div key={card.label} className="card">
									<div className="p-4 sm:p-5">
										<p className="mb-1 text-sm text-default-500 dark:text-default-400">
											{card.label}
										</p>
										<p className={`mb-0 text-2xl font-bold ${card.tone}`}>
											{card.value}
										</p>
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default StatesMain;
